import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {menuDisabledTicketUpdateReady} from '../redux/menu_disabled_tickets'
import apiService from '../services/apiservices'
import { headerDataUpdate, subHeaderDataUpdate,buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
//import  {ValidateEmail ,ValidatePhone,isLatitude,isLongitude} from '../../../common/ValidationFunctions/CommonValidation'
//import {MenuDisabledTicketStatus,MenuDisabledTicketReasons} from './DropDowns/index'

//import DateTimeField from "react-bootstrap-datetimepicker";

import {Reasons} from '../../../common/DropDowns/index'


function filterUnwantedData(menuDisabledTicketTicketsData) {
    // let data = {}
    // if (menuDisabledTicketTicketsData && menuDisabledTicketTicketsData.data && menuDisabledTicketTicketsData.data) {
    //     data = menuDisabledTicketTicketsData.data
    // }

    let newData = {}
            newData.id = menuDisabledTicketTicketsData.id ? menuDisabledTicketTicketsData.id : ""
            newData.store_name =  menuDisabledTicketTicketsData.store && menuDisabledTicketTicketsData.store.name ? menuDisabledTicketTicketsData.store.name : "NA"
            newData.kitchen_name =menuDisabledTicketTicketsData.store && menuDisabledTicketTicketsData.store.kitchen && menuDisabledTicketTicketsData.store.kitchen.name ? menuDisabledTicketTicketsData.store.kitchen.name+" - "+menuDisabledTicketTicketsData.store.kitchen.city.name : "NA"
            newData.kitchen_code =menuDisabledTicketTicketsData.store && menuDisabledTicketTicketsData.store.kitchen && menuDisabledTicketTicketsData.store.kitchen.code ? menuDisabledTicketTicketsData.store.kitchen.code : "NA"
            newData.city_name =menuDisabledTicketTicketsData.store && menuDisabledTicketTicketsData.store.kitchen && menuDisabledTicketTicketsData.store.kitchen.city && menuDisabledTicketTicketsData.store.kitchen.city.name ? menuDisabledTicketTicketsData.store.kitchen.city.name : "NA"

            newData.menu_name =  menuDisabledTicketTicketsData.menu && menuDisabledTicketTicketsData.menu.name ? menuDisabledTicketTicketsData.menu.name : "NA"
            newData.menu_id =  menuDisabledTicketTicketsData && menuDisabledTicketTicketsData.menu.id ? menuDisabledTicketTicketsData.menu.id : "NA"

            newData.reason =menuDisabledTicketTicketsData.reason ? menuDisabledTicketTicketsData.reason : "NA"
            newData.created =menuDisabledTicketTicketsData.created ? Helpers.getDateTimeFormatForUTC(menuDisabledTicketTicketsData.created) : "NA"

    return newData
}

class UpdateMenuDisabledTicket extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",

            brandName:null,
            remarks:null,

            reason:null,

            bulkReasonId: null,


            menuDisabledTicketsSelectedId:"",
            menuDisabledTicketTicketsData:{},
            menuDetails:[],
            disabledDate:false,
            
            brandNameErrorText: false,
            brandNameErrorData: '',

            reasonErrorText: false,
            reasonErrorData: '',        

            remarksErrorText: false,
            remarksErrorData: '',

            subTitle:Constants.EDIT_MENU_DISABLED_TICKET
            
        }
        this.isComponentStillMounted = true

        this.brandNameComponent = null
        this.brandNameSection = null

        this.reasonComponent = null
        this.reasonSection = null

        this.reasonComponent = null
        this.reasonSection = null

        this.remarksComponent = null
        this.remarksSection = null
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        
        if(this.props.menu_disabled_tickets && this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId && this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.EDIT_MENU_DISABLED_TICKET))
            this.setState({subTitle: Constants.EDIT_MENU_DISABLED_TICKET})
            this.props.dispatch(subHeaderDataUpdate())
            this.setState({
                menuDisabledTicketsSelectedId:this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId
            });

        }else{
            this.props.history.goBack();
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getMenuDisabledTicketData();
    }



    componentDidMount() {

    }

    getMenuDisabledTicketData = () =>{
        this.reasonSection = ReactDOM.findDOMNode(this.refs.reasonSection)
        this.remarksSection = ReactDOM.findDOMNode(this.refs.remarksSection)
        
        
        this.props.dispatch(menuDisabledTicketUpdateReady(false))
        if(this.props.menu_disabled_tickets && this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId && this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId !== null){
            apiService.getMenuDisabledTicketDetails(this.props.menu_disabled_tickets.menuDisabledTicketsSelectedId)
                .then(responseData => {
                    
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {

                        let menuDisabledTicketTicketsData=filterUnwantedData(responseData.data)

                        this.setState({
                            menuDisabledTicketTicketsData: menuDisabledTicketTicketsData 
                        });
                        this.getMenuDeatilsByMenuId(menuDisabledTicketTicketsData.menu_id)
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(menuDisabledTicketUpdateReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Fetching stores tickets got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
        }

    }


    getMenuDeatilsByMenuId = (menuDisabledTicketsSelectedId) =>{

            apiService.getMenuDeatilsByMenuId(menuDisabledTicketsSelectedId)
                .then(responseData => {
                    
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {

                        this.arrangeMenuDetails(responseData.data)
                        
                    }

                     this.props.dispatch(menuDisabledTicketUpdateReady(true))
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(menuDisabledTicketUpdateReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Fetching stores tickets got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })


    }


    arrangeMenuDetails = (data) => {

        let menuDetailsObj=[]
        

         Object.keys(data).map((value,index) => {
            let obj={
                "id":value,
                "name":data[value],
                "checked":false,
                "reason_id":null,
                "remarks":"",
                "search":true
            } 
            menuDetailsObj.push(obj)
            return true
        })

         this.setState({
             menuDetails:menuDetailsObj 
         });

    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 180) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 130) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

   

    mandateValidation =(inputName,reason)=>{
        let inputComponent =inputName+"Component"
        let inputErrorText =inputName+"ErrorText"
        let inputErrorData =inputName+"ErrorData"
        let inputSection =inputName+"Section"
        let errorMsg = Constants.NON_VALID_MSG_INPUT
        if(Constants.FORM_SELECT ===reason){
            errorMsg= Constants.NON_VALID_MSG_SELECT
            console.log("input name :::",inputName)
            console.log("input data :::",this.state[inputName])
        }
        if(this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === ""){
            this[inputComponent].focus()
            this.setState({[inputErrorText]:true,[inputErrorData]:errorMsg})
            this[inputSection].className= this[inputSection].className.replace(" has-error", "")
            this[inputSection].className += " has-error"
            return { reason: false, value: '' }
        }
        return { reason: true }
    }


checkBoxChange = (id,e) => {

    let menuDetails = this.state.menuDetails;

    menuDetails.map(function(item, index) {
        if (item['id'] === id) {
            item.checked = e.target.checked
        }
        return true
    })

     this.setState({
        menuDetails: menuDetails
    });

}
    onSaveClick = () => {


        let menuDetails=this.state.menuDetails;

        if(menuDetails.length>0){
            document.getElementById("searchSkuId").value =""
        }

            menuDetails.map(function(item, index) {
                 item.search = true
                 return true
            });

        this.setState({
            menuDetails: menuDetails
        });

        let data ={}

        let reasonObject = this.mandateValidation("reason",Constants.FORM_SELECT)
        if (reasonObject.reason) {
            data.reason_id = this.state.reason
        } else {
            return
        }

        let skuReasonMandatory=false
        if(data.reason_id==="100" || data.reason_id==="105" || data.reason_id==="106" || data.reason_id==="102" || data.reason_id==="107"){
            skuReasonMandatory=true
        }

        let remarksObject = this.mandateValidation("remarks",Constants.FORM_INPUT)
        if (remarksObject.reason) {
            data.remarks = this.state.remarks
        } else {
            return
        }

        let details=[]

        for (let i = menuDetails.length - 1; i >= 0; i--) {
            if(menuDetails[i]['checked']){
                let temp={}
                temp.product_id=menuDetails[i]['id']
                if(menuDetails[i]['reason_id'] && menuDetails[i]['reason_id']!==undefined && menuDetails[i]['reason_id']!==""){
                    temp.reason_id=menuDetails[i]['reason_id']
                }else{
                    this.dialog.show({
                            title: "Error!!",
                            body: "Please select reason for product - "+menuDetails[i]['name'],
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    return
                }

                temp.remarks=menuDetails[i]['remarks']

                // if(menuDetails[i]['remarks'] && menuDetails[i]['remarks']!==undefined && menuDetails[i]['remarks']!==""){
                //     temp.remarks=menuDetails[i]['remarks']
                // }else{
                //     this.dialog.show({
                //             title: "Error!!",
                //             body: "Please type remarks for product - "+menuDetails[i]['name'],
                //             actions: [
                //                 Dialog.OKAction(() => {
                //                 })
                //             ],
                //         })
                //     return
                // }
                details.push(temp);
            }
        }

        if(menuDetails.length>0 && details.length===0 && skuReasonMandatory){
                this.dialog.show({
                            title: "Error!!",
                            body: "Please select SKU(s) and update reason and remarks",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    return
        }


        this.props.dispatch(menuDisabledTicketUpdateReady(false))
        data.details=details
        data.status="CLOSED"
        let apiPayloadData=data

         apiService.updateMenuDisabledTicket(apiPayloadData,this.state.menuDisabledTicketTicketsData.id)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(menuDisabledTicketUpdateReady(true))
                        this.props.history.push("/dashboard/menuDisabledTickets/list")
                    } else {

                        this.props.dispatch(menuDisabledTicketUpdateReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.status ? responseData.status : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(menuDisabledTicketUpdateReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
      
        
    }



    reasonChangeMain = (data) => {
    this.reasonComponent.value=data.value
        this.setState({
            reason :data.value,
            reasonErrorText: false,
            reasonErrorData: ''
        })
        this.reasonSection.className= this.reasonSection.className.replace(" has-error", "")
    }


    reasonChangeSub = (data,id) => {

         let menuDetails = this.state.menuDetails;

        menuDetails.map(function(item, index) {
            if (item['id'] === id) {
                item.reason_id = data.value
            }
            return true
        })

         this.setState({
            menuDetails: menuDetails
        });
    }


    reasonChangeBulk = (data) => {
        
        let bulkReasonId=data.value

         let menuDetails = this.state.menuDetails;

        menuDetails.map(function(item, index) {            
                item.reason_id = bulkReasonId
            return true
        })

         this.setState({
            menuDetails: menuDetails,
            bulkReasonId:bulkReasonId
        });
    
    }


   storeTicketStatusChange = (data) => {
    this.reasonComponent.value=data.value
        this.setState({
            reason :data.value,
            reasonErrorText: false,
            reasonErrorData: ''
        })
        this.reasonSection.className= this.reasonSection.className.replace(" has-error", "")
    }


   storeTicketReasonsChange = (data) => {
    this.reasonComponent.value=data.value
        this.setState({
            reason :data.value,
            reasonErrorText: false,
            reasonErrorData: ''
        })
        this.reasonSection.className= this.reasonSection.className.replace(" has-error", "")
    }




    integerValidation = (value) => {
        if (/\D/.test(value)) {
            return true
        } else {
            return false
        }
    }

    onCancelClick = () => {
        this.props.history.goBack()
    }
    
    render() {
        return (
            <div className="line-item-edit">

                <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight }}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                    <h3 className="box-title" style={{ fontWeight: 600 }}>Update Ticket</h3>
                                </div>
                                <div className="form-horizontal">
                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Code :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.kitchen_code}
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Store :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.store_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Kitchen Name:</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.kitchen_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City:</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.city_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                         <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Menu :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.menu_name}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.reason}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Created on :</label>
                                                    <div className="col-sm-9">
                                                            {this.state.menuDisabledTicketTicketsData.created}
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                         </div>

                                         <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                          <div className="box-footer">

                                          </div>

                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.reasonSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Reason *</label>
                                                    <div className="col-sm-9" ref={el => this.reasonComponent = el}>
                                                       
                                                    <Reasons reasonChange={this.reasonChangeMain} selectedValue={this.state.reason} type="MENU_TICKET" />
                                                        <span className="help-block"style={{display: this.state.reasonErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.reasonErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                       <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el => this.remarksSection = el}>
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Remarks *</label>
                                                                <div className="col-sm-9">
                                                                    <textarea  style={{resize:"none"}} className="form-control" placeholder="Type remarks...." reason="text" ref={el => this.remarksComponent = el}
                                                                        onChange={(e) => {e.preventDefault() 
                                                                        this.keyedInputChange("remarks")}} />
                                                                    <span className="help-block"style={{display: this.state.remarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                        {this.state.remarksErrorData}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>

                                       <div className="col-md-12 col-sm-12 col-xs-12">

                                       <div className="box-footer">

                                       </div>

                                       <div className="col-md-12">
                                            {(()=>{
                                                if(this.state.menuDetails.length>0){
                                                    return(

                                            <div className="col-md-12">
                                                <div className="form-horizontal">
                                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                                        <div className="col-md-3">
                                                            <h4>Product SKUs</h4>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <p style={{float:"right",fontWeight: "800",fontSize: "1.2em",textTransform:"capitalize"}}>Bulk actions :</p>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <Reasons reasonChange={this.reasonChangeBulk} selectedValue={this.state.bulkReasonId} type="MENU_DETAIL_TICKET" />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <input placeholder="Search Sku" id="searchSkuId"  className="form-control" type="text"
                                                            onChange={(e) => {
                                                            e.preventDefault();
                                                            this.searhSkuInputChange(e)
                                                            }}
                                                            />
                                                        </div>
                                                    
                                                    <table className="table table-bordered table-hover table-striped table-responsive" style={{textAlign:"left"}}>
                                    
                                                        <thead>
                                                            <tr><th></th><th>SKU Name</th><th>Reason</th><th>Remarks</th></tr>
                                                        </thead>
                                                        <tbody>
                                                         {this.state.menuDetails.map((item, index) => (
                                                            this.state.menuDetails[index].search===true ?
                                                        <tr>
                                                        <td><input className="checkbox" type="checkbox" name="checkbox" value="value" style={{"float": "left"}} checked={this.state.menuDetails[index].checked} 
                                                        onChange={(e) => {
                                                            this.checkBoxChange(this.state.menuDetails[index].id,e)
                                                        }}
                                                        /></td>
                                                        <td>{this.state.menuDetails[index].name}</td>
                                                        <td> <Reasons reasonChange={this.reasonChangeSub} dataId={this.state.menuDetails[index].id} selectedValue={this.state.menuDetails[index].reason_id} type="MENU_DETAIL_TICKET" /></td>

                                                        <td>

                                                            <textarea className="form-control"  style={{resize: "none"}}placeholder="Type remarks...." reason="text" onChange={(e) => {e.preventDefault();
                                                                 this.inputChange(item,e,index,"remarks")
                                                            }} />


                                                        </td>

                                                        </tr>

                                                        : null

                                                        ))}
                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                            </div>

                                             )
                                                }else{
                                                    return(
                                                        <div className="col-md-12">
                                                            <p>No Product SKUs Found for this menu item!!</p>
                                                        </div>
                                                    )
                                                    
                                                }

                                            })()}



                                    </div>

                                </div>
                                        
                            </div>

                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-info pull-right"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onSaveClick()
                                            }}>
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }


    inputChange = (row,e,rowIndex,field_name) => {

        let menuDetails=this.state.menuDetails.slice();
           
             menuDetails.map(function(item) {
                if(item.id===row.id){
                    item[field_name]=e.target.value
                    return true;
                }

                return true
            });

             this.setState({
                menuDetails:menuDetails
             })
        }
        

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }


     searhSkuInputChange = (e) => {
        let searachValue=e.target.value.toLowerCase();

        let menuDetails=this.state.menuDetails;

        if(menuDetails!=="" && menuDetails!==undefined){
            menuDetails.map(function(item, index) {
                if (item['name'].toLowerCase().indexOf(searachValue)>-1) {
                    item.search = true
                }else{
                    item.search=false
                }
                return true
            })
        }else{
            menuDetails.map(function(item, index) {
                 item.search = true
                 return true
            });
        }

        this.setState({
            menuDetails: menuDetails
        });

    }

}
function mapStateToProps(state) {
    return {
        menu_disabled_tickets: state.menu_disabled_tickets,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(UpdateMenuDisabledTicket))


// WEBPACK FOOTER //
// ./src/modules/Menu Disabled Tickets/Components/UpdateMenuDisabledTicket.js